import { render, staticRenderFns } from "./GroupedLocationsByCity.vue?vue&type=template&id=52df36cf&scoped=true&"
import script from "./GroupedLocationsByCity.vue?vue&type=script&lang=ts&"
export * from "./GroupedLocationsByCity.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedLocationsByCity.vue?vue&type=style&index=0&id=52df36cf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df36cf",
  null
  
)

export default component.exports